export const variant = (prop, values) => {
  return props => {
    const variant = props[prop];
    if (variant && typeof variant === 'string' && values.hasOwnProperty(variant)) return values[variant.toString()];
    return values.$default || {};
  };
};
//# sourceMappingURL=styledTools.js.map